var React = require('react');

function Pallet (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 0v128l64-32 64 32V0h112a16 16 0 0 1 16 16v224a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16V16a16 16 0 0 1 16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M624 384a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h48v64H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h608a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-48v-64zm-336 64H128v-64h160zm224 0H352v-64h160zM384 128V0H256v128l64-32z","className":"fa-primary","key":2})]);
}

Pallet.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Pallet;

Pallet.default = Pallet;
